import { useCallback, useState } from 'react';

import {
  readStoredFavoriteRuns,
  toggleFavoriteRun,
  writeStoredFavoriteRuns,
} from '../lib/favorite-runs';

export interface FavoriteRuns {
  /** The starred run ids. Membership is the only question asked of it. */
  favoriteRunIds: ReadonlySet<string>;
  toggleFavorite: (executionId: string) => void;
}

/**
 * The reviewer's starred runs, persisted.
 *
 * Read once on mount rather than on every render: the only writer is this hook,
 * and the picker is a single mount per page, so there is nothing for a second
 * read to discover. A star set in another tab therefore arrives on the next
 * load — which is the same bargain the pane widths and the theme already make.
 */
export function useFavoriteRuns(): FavoriteRuns {
  const [favoriteRunIds, setFavoriteRunIds] = useState<ReadonlySet<string>>(
    readStoredFavoriteRuns
  );

  const toggleFavorite = useCallback((executionId: string) => {
    setFavoriteRunIds((currentFavoriteRunIds) => {
      const nextFavoriteRunIds = toggleFavoriteRun(
        currentFavoriteRunIds,
        executionId
      );
      writeStoredFavoriteRuns(nextFavoriteRunIds);
      return nextFavoriteRunIds;
    });
  }, []);

  return { favoriteRunIds, toggleFavorite };
}
